export const NO_ORG_UNIT = 'none';
export const NO_ORG_UNIT_LABEL = 'No organizational unit';
export const DELETED_ORG_UNIT_LABEL = 'Deleted organizational unit';
export const UNAVAILABLE_ORG_UNIT_LABEL = 'Unavailable organizational unit';
